export default "__VITE_ASSET__BhXlo2Cn__"